export { default } from './IntakeStatusCard';
